import { useTranslation } from 'react-i18next';
import DoorIcon from '@/components/icons/DoorIcon';
import ApartmentsLookup from '@/features/apartments/components/ApartmentsLookup';
import { useDashboardFilter } from '@/features/dashboard/hooks/useDashboardFilter';
import { DashboardPageFilterFormSchema } from '@/features/dashboard/validators/DashboardPageFilterValidator';
import { z } from 'zod';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { useEffect } from 'react';

type FormData = z.infer<typeof DashboardPageFilterFormSchema>;

const DashboardApartmentsFilter = () => {
	const { t } = useTranslation();

	const { filter, setFilter } = useDashboardFilter();

	const { control, watch, getValues } = useForm<FormData>({
		resolver: zodResolver(DashboardPageFilterFormSchema),
		values: {
			apartmentId: filter.apartmentId,
		},
	});

	useEffect(() => {
		setFilter({ apartmentId: getValues('apartmentId') });
	}, [watch('apartmentId')]);

	return (
		<>
			<ApartmentsLookup
				control={control}
				fieldName={'apartmentId'}
				label={''}
				placeholder={t('main.dashboard.components.filter.apartments.placeholder')}
				icon={DoorIcon}
				selectVariant={'single'}
				containerClassName={'w-32'}
			/>
		</>
	);
};

export default DashboardApartmentsFilter;
